import { createPortal } from 'react-dom';
import { X, User, Key, Trash2 } from 'lucide-react';

const EnquiryModal = ({
    enquiry,
    onClose,
    onUpdateStatus,
    onDelete
}) => {
    if (!enquiry) return null;

    return createPortal(
        <div 
            className="fixed inset-0 z-[9999] bg-slate-950/50 backdrop-blur-xs flex items-center justify-end animate-in fade-in duration-200"
            onClick={onClose}
        >
            <div 
                className="bg-white w-full max-w-md h-full shadow-2xl p-6 overflow-y-auto animate-in slide-in-from-right duration-300 flex flex-col justify-between"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="space-y-6">
                    <div className="flex items-center justify-between pb-4 border-b border-slate-100">
                        <h3 className="font-bold text-slate-800 text-lg">Enquiry Details</h3>
                        <button
                            type="button"
                            onClick={onClose}
                            className="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-xl transition-all cursor-pointer flex items-center justify-center"
                            aria-label="Close"
                        >
                            <X size={18} />
                        </button>
                    </div>

                    <div className="space-y-6 mt-6">
                        <div>
                            <span className="text-xs font-bold uppercase tracking-wider text-slate-400">Traveller Info</span>
                            <div className="mt-2 bg-slate-50 p-4 rounded-xl border border-slate-100 space-y-2">
                                <div className="flex items-center gap-2 text-sm font-bold text-slate-800">
                                    <User size={16} className="text-[#067978]" />
                                    {enquiry.traveller_name}
                                </div>
                                <div className="flex items-center gap-2 text-sm text-slate-600 font-mono">
                                    <Key size={16} className="text-[#067978]" />
                                    Booking ID: <span className="uppercase font-bold text-[#067978]">{enquiry.traveller_phone}</span>
                                </div>
                            </div>
                        </div>

                        <div>
                            <span className="text-xs font-bold uppercase tracking-wider text-slate-400">Package & Source</span>
                            <div className="mt-2 bg-slate-50 p-4 rounded-xl border border-slate-100 space-y-2">
                                <div className="text-sm font-bold text-slate-800">
                                    {enquiry.source_package_id?.title || 'Open Enquiry (General)'}
                                </div>
                                {enquiry.source && (
                                    <div className="text-xs text-slate-500 capitalize">
                                        Source: {enquiry.source.replace(/_/g, ' ')}
                                    </div>
                                )}
                            </div>
                        </div>

                        {enquiry.message && (
                            <div>
                                <span className="text-xs font-bold uppercase tracking-wider text-slate-400">Traveller Message</span>
                                <div className="mt-2 bg-teal-50/60 p-4 rounded-xl border border-teal-100 text-sm text-slate-700 leading-relaxed italic">
                                    "{enquiry.message}"
                                </div>
                            </div>
                        )}

                        <div>
                            <span className="text-xs font-bold uppercase tracking-wider text-slate-400">Update Status</span>
                            <div className="mt-2 flex gap-2 flex-wrap">
                                {['new', 'contacted', 'quoted'].map((st) => (
                                    <button
                                        key={st}
                                        type="button"
                                        onClick={() => onUpdateStatus && onUpdateStatus(enquiry._id, st)}
                                        className={`px-3 py-1.5 rounded-xl text-xs font-bold uppercase tracking-wider border cursor-pointer transition-all ${
                                            enquiry.status === st
                                                ? 'bg-[#067978] text-white border-[#067978] shadow-sm'
                                                : 'bg-white text-slate-600 border-slate-200 hover:bg-slate-50'
                                        }`}
                                    >
                                        {st}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Danger zone / Delete Action */}
                {onDelete && (
                    <div className="pt-6 border-t border-slate-100 mt-8">
                        <button
                            type="button"
                            onClick={() => onDelete(enquiry._id)}
                            className="w-full flex items-center justify-center gap-2 py-3 bg-rose-50 hover:bg-rose-600 text-rose-600 hover:text-white border border-rose-100 hover:border-rose-600 rounded-xl text-xs font-bold uppercase tracking-wider transition-all cursor-pointer"
                        >
                            <Trash2 size={15} />
                            Delete Enquiry
                        </button>
                    </div>
                )}
            </div>
        </div>,
        document.body
    );
};

export default EnquiryModal;
